/**
 * Admin Experience Detail Hook
 *
 * Fetches full experience detail for the admin detail modal.
 *
 * API Endpoint:
 *   GET /api/v1/admin/experiences/:id
 *
 * Story: SCRUM-843
 */

import { useState, useCallback } from 'react';
import apiRequest from '../../services/api';

export default function useAdminExperienceDetail() {
  const [experience, setExperience] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = useCallback(async (experienceId) => {
    if (!experienceId) { return; }

    try {
      setLoading(true);
      setError(null);

      const response = await apiRequest(`/api/v1/admin/experiences/${experienceId}`);

      if (response.success) {
        setExperience(response.data);
      }
    } catch (err) {
      setError(err.message || 'Failed to load experience details');
    } finally {
      setLoading(false);
    }
  }, []);

  const clearDetail = useCallback(() => {
    setExperience(null);
    setError(null);
  }, []);

  return {
    experience,
    loading,
    error,
    fetchDetail,
    clearDetail,
  };
}
